import { useState, useEffect } from 'react';
import { getAccount, getUser } from 'store/requests/auth';

export default () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const getData = async () => {
      try {
        const user = await getUser();
        setIsAuthenticated(true);
        if (!user) {
          // eslint-disable-next-line no-throw-literal
          throw false;
        }
        await getAccount(user.sub);
      } catch (error) {
        // logout();
        setIsAuthenticated(false);
      }
      setLoading(false);
    };

    getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { loading, isAuthenticated };
};
